import { render, staticRenderFns } from "./CdbCustomerBasicMerge.vue?vue&type=template&id=0638f906&scoped=true&"
import script from "./CdbCustomerBasicMerge.vue?vue&type=script&lang=js&"
export * from "./CdbCustomerBasicMerge.vue?vue&type=script&lang=js&"
import style0 from "./CdbCustomerBasicMerge.vue?vue&type=style&index=0&id=0638f906&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0638f906",
  null
  
)

export default component.exports